import { PaipanData, Pillar } from './types';

export const mockPaipanData: PaipanData = {
  name: '即时局',
  gender: 'male',
  lunarDate: '庚午年五月廿三午時',
  lunarDate_en: 'Geng-Wu Year, 5th Month, 23rd Day, Wu Hour',
  lunarDate_ko: '경오년 5월 23일 오시',
  lunarDate_ja: '庚午年 五月二十三日 午時',
  solarDate: '1990-06-15 12:00',
  birthPlace: '香港 九龍城區',
  birthPlace_en: 'Hong Kong, Kowloon City',
  birthPlace_ko: '홍콩 구룡성구',
  birthPlace_ja: '香港 九龍城区',
  trueSolarTime: '1990-06-15 11:37',
  coordinates: '北纬22.32 东经114.17',
  dayMaster: '乙木居半',
  nayin: '大溪水',
  kongWang: '寅卯',
  kongWang2: '',
  xunShou: '甲辰旬',
  yearKongWang: '戌亥',
  monthKongWang: '戌亥',
  dayKongWang: '寅卯',
  hourKongWang: '申酉',
  shengXiao: '马',
  renYuanSiLing: '丙火用事',
  jieQiDesc: '山生于惊蛰后13天13小时，清明前16天15小时',
  jieQiDesc_en: 'Born 13 days 13 hrs after Insects Wake, 16 days 15 hrs before Clear & Bright',
  jieQiDesc_ko: '경칩 후 13일 13시간, 청명 전 16일 15시간에 출생',
  jieQiDesc_ja: '啓蟄後13日13時間、清明前16日15時間に生まれ',
  prevSolarTermName: '惊蛰',
  prevSolarTermName_en: 'Awakening of Insects',
  prevSolarTermName_ko: '경칩',
  prevSolarTermName_ja: '啓蟄',
  prevSolarTermDate: '2026-03-05 21:58:43',
  nextSolarTermName: '清明',
  nextSolarTermName_en: 'Clear and Bright',
  nextSolarTermName_ko: '청명',
  nextSolarTermName_ja: '清明',
  nextSolarTermDate: '2026-04-05 02:39:43',
  jieTaiDate: '2026-03-05 21:58:43',
  qingMingDate: '2026-04-05 02:39:43',
  zodiacSign: '双鱼座位 (Pisces)',
  zodiacSign_en: 'Pisces',
  zodiacSign_ko: '물고기자리',
  zodiacSign_ja: '魚座',
  chineseConstellation: '金牛座 西方白虎',
  chineseConstellation_en: 'Taurus (Western)',
  chineseConstellation_ko: '황소자리 (서양)',
  chineseConstellation_ja: '牡牛座（西洋）',
  taiYuan: '癸酉（剑锋金）',
  taiXi: '丙寅（炉中火）',
  mingGong: '辛巳（白蜡金）',
  shenGong: '己丑（霹雳火）',
  dayMasterXiXing: '壬癸水',
  yangYinRef: '阳男',
  wangShuaiRef: '偏弱',
  geJuRef: '七杀格',
  geJuRef_en: 'Seven Killings',
  geJuRef_ko: '칠살격',
  geJuRef_ja: '七殺格',
  mingGua: '乾（西四命）',
  mingGua_en: 'Qian (West-4 Fate)',
  mingGua_ko: '건(서사명)',
  mingGua_ja: '乾（西四命）',
};

export const mockPillars: Pillar[] = [
  {
    label: '年柱',
    mainStar: '劫财',
    tianGan: '庚',
    diZhi: '午',
    cangGan: ['丁七杀', '己偏印'],
    xingYun: '病',
    ziZuo: '沐浴',
    kongWang: '辰巳',
    naYin: '路旁土',
    shenSha: '',
    tianGanColor: '#C0C0C0',
    diZhiColor: '#D14B45',
    cangGanColors: ['#D14B45', '#E8C39E'],
  },
  {
    label: '月柱',
    mainStar: '伤官',
    tianGan: '壬',
    diZhi: '午',
    cangGan: ['丁七杀', '己偏印'],
    xingYun: '病',
    ziZuo: '胎',
    kongWang: '辰巳',
    naYin: '杨柳木',
    shenSha: '',
    tianGanColor: '#4A90D9',
    diZhiColor: '#D14B45',
    cangGanColors: ['#D14B45', '#E8C39E'],
  },
  {
    label: '日柱',
    mainStar: '比肩',
    tianGan: '辛',
    diZhi: '亥',
    cangGan: ['壬伤官', '甲正财'],
    xingYun: '沐浴',
    ziZuo: '沐浴',
    kongWang: '寅卯',
    naYin: '钗钏金',
    shenSha: '',
    tianGanColor: '#C0C0C0',
    diZhiColor: '#4A90D9',
    cangGanColors: ['#4A90D9', '#7BC67E'],
    isHighlight: true,
  },
  {
    label: '时柱',
    mainStar: '正财',
    tianGan: '甲',
    diZhi: '午',
    cangGan: ['丁七杀', '己偏印'],
    xingYun: '病',
    ziZuo: '死',
    kongWang: '辰巳',
    naYin: '沙中金',
    shenSha: '',
    tianGanColor: '#7BC67E',
    diZhiColor: '#D14B45',
    cangGanColors: ['#D14B45', '#E8C39E'],
  },
  {
    label: '胎柱',
    tianGan: '己',
    diZhi: '巳',
    cangGan: ['丙正官', '庚劫财', '戊正印'],
    xingYun: '死',
    ziZuo: '长生',
    kongWang: '戌亥',
    naYin: '大林木',
    shenSha: '',
    tianGanColor: '#E8C39E',
    diZhiColor: '#D14B45',
    cangGanColors: ['#D14B45', '#C0C0C0', '#E8C39E'],
  },
  {
    label: '胎元',
    tianGan: '癸',
    diZhi: '酉',
    cangGan: ['辛比肩'],
    xingYun: '临官',
    ziZuo: '病',
    kongWang: '戌亥',
    naYin: '剑锋金',
    shenSha: '',
    tianGanColor: '#4A90D9',
    diZhiColor: '#C0C0C0',
    cangGanColors: ['#C0C0C0'],
  },
];

// 节气索引列表（0-11 对应 bazi.jieQi.0 到 bazi.jieQi.11）
export const jieQiList = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11] as const;
